module.exports = __webpack_public_path__ + "static/media/shape3_5.f1de02c4.obj";